/**
 * Sticky Mobile Add-to-Cart Bar
 * Shows a fixed bottom bar on mobile when the main add-to-cart is scrolled out of view
 */

class StickyAddToCart {
  constructor() {
    this.stickyBar = document.querySelector('.sticky-atc');
    this.mainAddToCart = document.querySelector('.product-form__submit');
    this.stickyButton = document.querySelector('.sticky-atc__button');

    if (!this.stickyBar || !this.mainAddToCart) return;

    this.isVisible = false;
    this.scrollThreshold = 100; // pixels past the main button

    this.init();
  }

  init() {
    this.bindEvents();
    this.checkVisibility();
  }

  bindEvents() {
    // Scroll listener with throttle
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.checkVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Click on sticky button scrolls to main form and triggers click
    if (this.stickyButton) {
      this.stickyButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollToForm();
      });
    }

    // Listen for variant changes to update price
    document.addEventListener('variant:changed', (e) => {
      this.updatePrice(e.detail);
    });
  }

  checkVisibility() {
    if (!this.mainAddToCart) return;

    const rect = this.mainAddToCart.getBoundingClientRect();
    const shouldShow = rect.bottom < -this.scrollThreshold;

    if (shouldShow && !this.isVisible) {
      this.show();
    } else if (!shouldShow && this.isVisible) {
      this.hide();
    }
  }

  show() {
    this.isVisible = true;
    this.stickyBar.classList.add('sticky-atc--visible');
  }

  hide() {
    this.isVisible = false;
    this.stickyBar.classList.remove('sticky-atc--visible');
  }

  scrollToForm() {
    const productForm = document.querySelector('.product-form');
    if (productForm) {
      const headerHeight = document.querySelector('.header-wrapper')?.offsetHeight || 0;
      const targetPosition = productForm.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Focus the main add to cart button after scroll
      setTimeout(() => {
        if (this.mainAddToCart) {
          this.mainAddToCart.focus();
        }
      }, 500);
    }
  }

  updatePrice(variant) {
    const priceElement = this.stickyBar.querySelector('.sticky-atc__price');
    if (!priceElement || !variant) return;

    const formatMoney = (cents) => {
      return '$' + (cents / 100).toFixed(2);
    };

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceElement.innerHTML = `<s>${formatMoney(variant.compare_at_price)}</s> ${formatMoney(variant.price)}`;
    } else {
      priceElement.textContent = formatMoney(variant.price);
    }

    // Update button state
    if (this.stickyButton) {
      this.stickyButton.disabled = !variant.available;
      this.stickyButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new StickyAddToCart();
});

// Also initialize on Shopify section load (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new StickyAddToCart();
  });
}
